// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// Afidium
import { PriceFieldsetComponent } from './price-fieldset.component';
import { NumberFieldModule } from '../../fields/number-field/number-field.module';
import { MultiSelectFieldModule } from '../../fields/multiselect-field/multiselect-field.module';
import { NumberModule } from "libraries/module/formbuilder/fields/number/number.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    declarations: [
        PriceFieldsetComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NumberFieldModule,
        MultiSelectFieldModule,
        NumberModule,
        FontAwesomeModule,
    ],
    exports: [
        PriceFieldsetComponent,
    ],
    providers: [],
})
export class PriceFieldsetModule {}
